<template>
  <el-col :span="24">
    <el-col :span="24" style="text-align: right;">
      <el-button @click='add' type="primary" class="right" >添加</el-button>
    </el-col>
    <el-table :data="tableData" style="width: 100%" max-height="800">
      <el-table-column label="序号ID" width='100px' prop="id"> </el-table-column>

      <el-table-column  label="服务人员" width='200px' >
      	<template slot-scope='scope'>
          <el-input v-model="scope.row.shop_waiter" @blur="modify_waiter(scope.row.id,$event)" ></el-input>
      	</template>
      </el-table-column>
      <el-table-column  label="操作"  width='200px' >
      	<template slot-scope='scope'>
      		<el-row>
      			<el-col>
              <el-button @click='delete_waiter(scope.row.id)' >删除</el-button>
      			</el-col>
      		</el-row>
      	</template>
      </el-table-column>
    </el-table>
  </el-col>
</template>


<script>
  import {
      protocol_data_ShopWaiter_get,protocol_data_ShopWaiter_add,protocol_data_ShopWaiter_edit,protocol_data_ShopWaiter_delete
    } from "@/assets/js/network/request";

  export default {
    name: "hello",
    data() {
      return {
        tableData: [],

        value:"",
        dialogVisible:false,
        select_id:0
      };
    },
    mounted() {
      this.get_waiter_data()
    },
    methods: {
      get_waiter_data(){
        let _this=this;
        protocol_data_ShopWaiter_get().then((res1)=>{
           _this.tableData=res1.ret;
        })
      },
      add(){
          let _this=this;
          protocol_data_ShopWaiter_add('').then((res)=>{
            console.log(res)
            _this.$message({
              message: '添加成功',
              type: 'success'
            });
            _this.get_waiter_data()
         })
      },
      modify_waiter(id,event){
        let _this=this;
        protocol_data_ShopWaiter_edit(id,event.target.value).then((res)=>{
            console.log(res)
            _this.$message({
              message: '修改成功',
              type: 'success'
            });

        })
      },
     delete_waiter(id){
        let _this=this;
        protocol_data_ShopWaiter_delete(id).then((res)=>{
            console.log(res)
            _this.$message({
              message: '删除成功',
              type: 'success'
            });
            _this.get_waiter_data()
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/ShopWaiter.vue